import React, { useState } from "react";
import { ReactComponent as ArrowRight } from './reshot-icon-arrow-left-4NA6KJF8CU.svg';
import { ReactComponent as ArrowLeft } from './reshot-icon-arrow-right-ZP2WDL9B8N.svg';
import automatedCalendarImage from './images/Events.png';
import googleAiImage from './images/Googleai.png';
import socalFurspng from './images/SocalFursUpdated.png'
import jewelry from './Screenshot 2025-05-08 at 9.59.35 AM.png'
import SI from "./images/SI Auto Tracker.png"      
import socalmap from "./images/socalmap.png" 
import { Link } from "react-router-dom";
import { ReactComponent as Icon1 } from './svg/python-svgrepo-com.svg';
import { ReactComponent as Icon2 } from './svg/react-svgrepo-com.svg';
import { ReactComponent as Icon3 } from './svg/gemini-logo.svg';
import amatuer from "./AmatuerGolf.png"
import './ProjectPage.css';
// commit

const Carousel = ({ data }) => {
  const [slide, setSlide] = useState(0);

  const nextSlide = () => {
    if (slide === data.length - 1) 
    {
      setSlide(0);
    } else 

    {
      setSlide(slide + 1);
    }
  };
  
  const prevSlide = () => {
    if (slide === 0) {
      setSlide(data.length - 1);
    } else 
    
    {
      setSlide(slide - 1);
    }
  };

  return (
    <div className="carousel">
      <ArrowLeft onClick={prevSlide} className="arrow arrow-left" />
      {data.map((item, idx) => {
        return (
          <img
            src={item.src}
            alt={item.alt}
            key={idx}
            className={slide === idx ? "slide" : "slide slide-hidden"}
          />
        );
      })}
      <ArrowRight
        onClick={nextSlide}
        className="arrow arrow-right"
      />
      <span className="indicators">
        {data.map((_, idx) => {
          return (
            <button
              key={idx}
              className={
                slide === idx ? "indicator" : "indicator indicator-inactive"
              }
              onClick={() => setSlide(idx)}
            ></button>
          );
        })}
      </span>
    </div>
  );
};

export default function ExperiencePage() {

  const data = [
    {src: socalFurspng, alt: "socalfurs.com"},
    {src:socalmap, alt:"socalfurrymap"},
    { src: automatedCalendarImage, alt: "Automated Calendar" },
    { src: googleAiImage, alt: "Automated Calendar" },
  ];

  const data2 =[
    { src: jewelry, alt: "Jewelry" }
  ];


  const data3 = [
    {src: SI, alt: "Student Tracking"}
  ];

  return (

    <div className="App">

        <div className = "home-page-container">
          
       

          <div className = "green-line-bottom"> 

            <div className = "link-container">
                  <heading className = "header-avry-5"> Experience </heading>

              </div> 

         
          </div>

            
                <div className = "container-carousel">
                                        <header style={{fontSize:28}}className="header-avry2">Current Employment </header>
                                       {/* <a className = "project-github" href = "https://avryjacksoncom.github.io">Project Notes</a> */}
                            {/* <a href = "https://avryjacksoncom.github.io">Project Notes</a> */}
                             <a href = "https://www.amateurgolf.com/"><h1 id = "jewelryexchange1" style ={{color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}className = "header-avry3">Software Engineer: AmatuerGolf.com</h1></a>
                                       <img className = "img-ag2" src={amatuer}>
                                       </img>
                                     <header className="header-avry3">Tech Stack: </header>
                                       <div className="icon-group">
                                         <div className="icon-item">
                                           <Icon1 className="icon-img" title="Python" />
                                           <p className="icon-label">Python</p>
                                         </div>
                                         <div className="icon-item">
                                           <Icon2 className="icon-img" title="React" />
                                           <p className="icon-label">React</p>
                                         </div>
                                         <div className="icon-item">
                                           <Icon3 className="icon-img" title="Gemini AI" />
                                           <p className="icon-label">Gemini AI</p>
                                         </div>
                                       </div>
                                       {/* <Link style={{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}to ="/socalfurs"><h3>Project Details</h3></Link> */}
                                          <p style={{fontSize:18.1}} className = "paragraph-about-me">
                                 Currently a software developer at AmateurGolf, where I’m building tools to streamline workflows for their 
                                 writers across multiple applications. I’m creating systems that automate repetitive tasks, integrate data 
                                 from different sources, and help writers focus on content creation rather than manual processes. 
                                 Using Python and other technologies, I’m developing solutions that improve efficiency and support a 
                                 growing team of content creators.
                                       </p>
                           
                                     {/* end of carousel compenent container */}
                                     </div>
                                        <div className = "green-line-bottom">
                
                   </div>
              {/* Carousel Component */}

                <div className = "green-line-bottom"> 
                <div className = "container-carousel">
                {/* <a className = "project-github" href = "https://avryjacksoncom.github.io">Project Notes</a> */}
                <a style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}href = "https://socalfurs.com/"><header style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}className ="header-avry3">Socalfurs.com</header></a>
                <Carousel data={data} />
              <header className="header-avry3">Details: Lead Dev</header>
                    <Link style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}to ="/socalfurs"><h3>Project Details</h3></Link>
                <div className="icon-group">
                  <div className="icon-item">
                    <Icon1 className="icon-img" title="Python" />
                    <p className="icon-label">Python</p>
                  </div>
                  <div className="icon-item">
                    <Icon2 className="icon-img" title="React" />
                    <p className="icon-label">React</p>
                  </div>
                  <div className="icon-item">
                    <Icon3 className="icon-img" title="Gemini AI" />
                    <p className="icon-label">Gemini AI</p>
                  </div>
                </div>
                

                   <p  style = {{fontSize:18.1}} className = "paragraph-about-me">
                  I'm the lead developer for SocalFurs. I created an automated calendar to make the furry fandom easier to access
                   for people who might not know much about it.Many discover the community only through personal connections, 
                   so I wanted to build a tool that helps anyone find
                  and join events easily. Using Python, Google AI, and React, I developed a system that converts Telegram messages 
                  into Google Calendar events, serving a community of over 3,000 members and 100 organizers. It handles thousands of
                   updates each week and syncs every few minutes to stay accurate. I also built a companion website so people can browse 
                  and search events easily, helping both newcomers and organizers save time.
                </p>
       
                </div>
              {/* end of carousel compenent container */}
              </div>
       

               {/* Carousel Component */}
                    <div className = "green-line-bottom">
               <div className = "container-carousel">
               {/* <a href = "https://avryjacksoncom.github.io">Project Notes</a> */}
                <h1  id =  "jewelryexchange1" style = {{ paddingLeft:10,color: "#1bbb75", textDecoration: "None", textDecorationColor: "green" }}className = "header-avry3">Jewelry Exchange In-Store Customer Survey</h1>
                <img className = "image-jewelry" src={jewelry}></img>
                   <header className="header-avry3">Details: Freelance</header>
                <div className="icon-group">
                  <div className="icon-item">
                    <Icon1 className="icon-img" title="Python" />
                    <p className="icon-label">Python</p>
                  </div>
                  <div className="icon-item">
                    <Icon2 className="icon-img" title="React" />
                    <p className="icon-label">React</p>
                  </div>
                </div>
                <p style = {{fontSize:18.1}} className = "paragraph-about-me">
                I built a simple customer survey system using FastAPI and React to track how people hear about us. 
                Customers scan a QR code in the store and select where they found us, like Google or Bing, 
                and their responses are saved in a CSV file. This helps our managers see which ads are working without 
                relying on employees to remember to ask. The system now gets over 25 responses each weekend and gives 
                us real data to guide some of our marketing efforts. I also automated duplicate detection in a 
                directory of over 12,000 images using Python, 
                successfully deleting more than 200 redundant files and streamlining storage management.
                </p>

                    {/* <Carousel data={data2} /> */}
            
                  
                 </div>
              {/* end of carousel compenent container */}
              </div>
         <div className = "container-carousel">
                       {/* <a className = "project-github" href = "https://avryjacksoncom.github.io">Project Notes</a> */}
                       <a style={{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}href = "https://github.com/avryjacksoncom/jewelry-script-singular-files"><header style = {{ color: "#1bbb75", textDecoration: "None", textDecorationColor: "green" }}className ="header-avry3">Jewelry Duplicate Files Script</header></a>
                     
             
                       <div className="icon-group">
                         <div className="icon-item">
                           <Icon1 className="icon-img" title="Python" />
                           <p className="icon-label">Python</p>
                         </div>
              
                       </div>
                          <p style = {{fontSize:18.1}} className = "paragraph-about-me">
                      At Jewelry Exchange, I automated duplicate detection in a 12,000+ image directory using Python, successfully
                       removing more than 200 redundant files
                       </p>
           
                     {/* end of carousel compenent container */}
                     </div>

              <div className = "green-line-bottom"> </div>

              <div className = "container-carousel">
              {/* <a className = "project-github" href = "https://avryjacksoncom.github.io">Project Notes</a> */}
                <header style = {{ color: "#1bbb75", textDecoration: "None", textDecorationColor: "green" }}className = "header-avry3">Tutor Tracking</header>
                   <Carousel data={data3} />
                 <header className="header-avry3">Details: Tutor</header>
                <div className="icon-group">
                  <div className="icon-item">
                    <Icon1 className="icon-img" title="Python" />
                    <p className="icon-label">Python</p>
                  </div>
                  <div className="icon-item">
                    <Icon2 className="icon-img" title="React" />
                    <p className="icon-label">React</p>
                  </div>
                </div>
                <p  style = {{fontSize:18.1}} className = "paragraph-about-me">
                  I worked as a tutor supporting professors and students in computer science 
                  labs, helping with programming, algorithms, and software engineering. To make 
                  tracking student support easier, I built a Python and React-based program that
                  records student tracking in tutoring sessions and stores the data in Excel.
                  The tool simplified attendance tracking and weekly reports, saving time for me.
                  I gave some of my comp sci tutoring collegaues the repo.  



                </p>

                    {/* <Carousel data={data2} /> */}

              {/* end of carousel compenent container */}
              </div>


        {/* Home-page-container div */}
        </div>

    {/* End of entire div */}
    </div>
  );
}
